import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CommonRequestState {
  copyId: number | null;
}

const initialState: CommonRequestState = {
  copyId: null,
};

const commonCopySlice = createSlice({
  name: 'copy',
  initialState,
  reducers: {
    setCopyId: (state, action: PayloadAction<number>) => {
      state.copyId = action.payload;
    },
    clearCopyId: state => {
      state.copyId = null;
    },
  },
});

export const { setCopyId, clearCopyId } = commonCopySlice.actions;

export default commonCopySlice;
